import "fixed-data-table-2/dist/fixed-data-table.css";
import noFilesImg from "static/to_do_list_nothing.jpg";

import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { Table, Column, Cell } from "fixed-data-table-2";

import { TextCell } from "components/FixedDataTableCells";
import { getSoloPhysNum } from "util/solo";

const formatBytes = bytes => {
  if (!bytes) return "-";
  if (bytes > 1e3 && bytes < 1e6) return `${Math.round(bytes / 1e3)} kB`;
  if (bytes > 1e6 && bytes < 1e9) return `${Math.round(bytes / 1e6)} MB`;
  if (bytes > 1e9 && bytes < 1e12) return `${Math.round(bytes / 1e9)} GB`;
  return `${bytes} B`;
};

const styles = {
  textInputStyle: {
    width: "100%",
    background: "transparent",
    border: "none"
  },
  warnButtonStyle: {
    background: "#c99806",
    borderRadius: "8px",
    border: "none",
    color: "white",
    fontWeight: 500
  },
  headerStyle: {
    marginTop: 5,
    fontWeight: "bold"
  },
  tableFont: {
    fontFamily: "Roboto",
    fontSize: "14px"
  }
};

const FilesListTable = props => {
  if (!props.soloFilesFetching) {
    if (props.soloFilesList.length === 0) {
      return <img src={noFilesImg} alt="no files to annotate" />;
    }
    return (
      <div style={styles.tableFont}>
        <Table
          rowsCount={props.soloFilesList.length}
          rowHeight={30}
          headerHeight={30}
          width={props.width - 5}
          height={
            ((props.soloFilesList.length > 10
              ? 10
              : props.soloFilesList.length) +
              1) *
            30
          }
          onRowClick={props.onFilesTableRowSelect}
        >
          <Column
            cell={({ rowIndex, ...colProps }) => {
              const soloData = props.soloFilesList[rowIndex];
              return (
                <Cell {...colProps}>
                  <input
                    type="checkbox"
                    checked={props.soloFilesBeingAnnotated.includes(
                      soloData.soloFilePk
                    )}
                    onChange={() => {}} // Do default row select
                  />
                </Cell>
              );
            }}
            width={40}
          />
          <Column
            header="Survey date"
            cell={({ rowIndex, ...colProps }) => {
              const date = props.soloFilesList[rowIndex].collectionDt;
              const dt = date
                ? moment(date).format("ll")
                : "Cast detection failed";
              return (
                <Cell {...colProps} title={moment(date).format()}>
                  {dt}
                </Cell>
              );
            }}
            width={130}
            flexGrow={1}
          />
          <Column
            header="Solo number"
            cell={({ rowIndex, ...colProps }) => {
              const soloData = props.soloFilesList[rowIndex];
              return (
                <Cell {...colProps}>
                  {getSoloPhysNum(soloData.deviceSn, props.soloUIDLookup)}
                </Cell>
              );
            }}
            width={70}
            flexGrow={1}
          />
          <Column
            header="Casts"
            cell={colProps => (
              <TextCell
                {...colProps}
                data={props.soloFilesList}
                field="numCasts"
              />
            )}
            width={30}
            flexGrow={1}
          />
          <Column
            header="Filename"
            cell={colProps => (
              <TextCell
                {...colProps}
                data={props.soloFilesList}
                field="filename"
              />
            )}
            width={180}
            flexGrow={1}
          />
          <Column
            header="Size"
            cell={({ rowIndex, ...colProps }) => (
              <Cell {...colProps}>
                {formatBytes(props.soloFilesList[rowIndex].fileBytes)}
              </Cell>
            )}
            width={50}
            flexGrow={1}
          />
          <Column
            header="Remove from list"
            cell={({ rowIndex, ...colProps }) => {
              const soloFile = props.soloFilesList[rowIndex];
              return (
                <Cell {...colProps}>
                  <input
                    type="button"
                    disabled={!soloFile.comments}
                    style={
                      soloFile.comments ? styles.warnButtonStyle : undefined
                    }
                    value="can't annotate"
                    onClick={() => props.onRemoveFileClick(soloFile.soloFilePk)}
                  />
                </Cell>
              );
            }}
            width={110}
            flexGrow={1}
          />
          <Column
            header="
              Reason not Annotated (required)
            "
            cell={({ rowIndex, ...colProps }) => {
              const soloFile = props.soloFilesList[rowIndex];
              return (
                <Cell {...colProps}>
                  <input
                    type="text"
                    style={styles.textInputStyle}
                    value={soloFile.comments || ""}
                    onChange={e =>
                      props.onFileCommentsChange(
                        soloFile.soloFilePk,
                        e.target.value
                      )
                    }
                  />
                </Cell>
              );
            }}
            width={200}
            flexGrow={2}
          />
        </Table>
      </div>
    );
  }
  return null;
};

FilesListTable.propTypes = {
  width: PropTypes.number,
  soloFilesFetching: PropTypes.bool.isRequired,
  soloFilesBeingAnnotated: PropTypes.arrayOf(PropTypes.number),
  soloFilesList: PropTypes.arrayOf(
    PropTypes.shape({
      filename: PropTypes.string.isRequired,
      soloFilePk: PropTypes.number.isRequired,
      numCasts: PropTypes.number,
      fileBytes: PropTypes.number,
      collectionDt: PropTypes.string,
      deviceSn: PropTypes.string,
      comments: PropTypes.string
    })
  ).isRequired,
  onFilesTableRowSelect: PropTypes.func.isRequired,
  onFileCommentsChange: PropTypes.func.isRequired,
  onRemoveFileClick: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  soloUIDLookup: PropTypes.object.isRequired
};

FilesListTable.defaultProps = {
  width: 900,
  soloFilesBeingAnnotated: []
};

export default FilesListTable;
